import { render, staticRenderFns } from "./DoctorPageLpuListLpu.vue?vue&type=template&id=892e1b3e&scoped=true&"
import script from "./DoctorPageLpuListLpu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPageLpuListLpu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorPageLpuListLpu.vue?vue&type=style&index=0&id=892e1b3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892e1b3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('892e1b3e')) {
      api.createRecord('892e1b3e', component.options)
    } else {
      api.reload('892e1b3e', component.options)
    }
    module.hot.accept("./DoctorPageLpuListLpu.vue?vue&type=template&id=892e1b3e&scoped=true&", function () {
      api.rerender('892e1b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListLpu.vue"
export default component.exports